import(/* webpackMode: "eager" */ "/home/u199988525/domains/glanzcrm.com/hbuilds/source/src/app/global-error.tsx");
